interface LoaderProps {
    width?: string;
    height?: string;
}

const Loader = ({ width = "100", height = "100" }: LoaderProps) => {
    return <img src="/FinalLoader.gif" style={{ width: `${width}px`, height: `${height}px` }} />;
};

export default Loader;
